<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="ntaxPartners.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="ntaxPartner"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :ntaxPartner="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="ntaxPartners && ntaxPartners.per_page"
        layout="total, prev, pager, next"
        :total="ntaxPartners && ntaxPartners.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
    };
  },
  computed: {
    ntaxPartners() {
      return this.$store.getters['ntaxPartner/ntaxPartners'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['ntaxPartner/tableConfig']));
    },
    loading() {
      return this.$store.getters['ntaxPartner/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    await this.$store.dispatch('ntaxPartner/fetchAll');
  },

  methods: {
    handleCurrentChange(val) {
      this.$store.commit('ntaxPartner/setCurrentPage', val);
      this.$store.dispatch('ntaxPartner/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('ntaxPartner/setSorting', { prop, order});
        this.$store.dispatch('ntaxPartner/fetchAll');
      }
    },
  },
};
</script>
